import React, { useState } from "react"
import { Button } from "reactstrap"
import { useStore } from "../../contexts/StoreContext"
import { getFiscalBannerVariant } from "../../helpers/store_access_helper"
import FiscalInformationModal from "./FiscalInformationModal"

const content = {
  missing_information: {
    icon: "bx bx-file",
    title: "Complétez vos informations fiscales",
    message: "Renseignez vos informations fiscales pour démarrer leur validation. Une fois transmises, un membre de l’équipe Wevalo prendra contact avec vous afin de finaliser l’activation de la publication de vos paniers.",
    button: "Compléter mes informations",
  },
  pending_review: {
    icon: "bx bx-time-five",
    title: "Informations fiscales en cours de validation",
    message: "Vos informations fiscales ont bien été transmises. Un membre de l’équipe Wevalo prendra contact avec vous pour finaliser leur validation. Vous pourrez ensuite publier vos paniers.",
  },
  rejected: {
    icon: "bx bx-error-circle",
    title: "Informations fiscales à corriger",
    message: "Certaines informations fiscales doivent être corrigées avant de pouvoir publier des paniers.",
    button: "Corriger mes informations",
  },
}

const FiscalInformationBanner = () => {
  const { store } = useStore()
  const [modalOpen, setModalOpen] = useState(false)
  const variant = getFiscalBannerVariant(store)

  if (!variant) return null
  const banner = content[variant]

  return (
    <>
      <div className={`fiscal-banner fiscal-banner-${variant}`}>
        <span className="fiscal-banner-icon"><i className={banner.icon} /></span>
        <div className="fiscal-banner-copy">
          <h5>{banner.title}</h5>
          <p>{banner.message}</p>
        </div>
        {banner.button && (
          <Button color="primary" onClick={() => setModalOpen(true)}>{banner.button}</Button>
        )}
      </div>
      <FiscalInformationModal isOpen={modalOpen} toggle={() => setModalOpen(open => !open)} />
    </>
  )
}

export default FiscalInformationBanner
